import * as authHooks from "@rentiohq/shared-frontend/dist/redux/auth/auth.hooks";
import * as contactSelectors from "@rentiohq/shared-frontend/dist/redux/contact/contact.selectors";
import { useGetByPropertyId as useGetPropertyAmenities } from "@rentiohq/shared-frontend/dist/reduxV2/propertyAmenity/propertyAmenity.hooks";
import * as rentRegistrationActions from "@rentiohq/shared-frontend/dist/reduxV2/rentRegistration/rentRegistration.actions";
import * as rentRegistrationSelectors from "@rentiohq/shared-frontend/dist/reduxV2/rentRegistration/rentRegistration.selectors";
// import * as contractHooks from "@rentiohq/shared-frontend/dist/reduxV2/contract/contract.hooks";
// import * as propertyHooks from "@rentiohq/shared-frontend/dist/reduxV2/property/property.hooks";
import { IContact } from "@rentiohq/shared-frontend/dist/types/contact.types";
import { IContract } from "@rentiohq/shared-frontend/dist/types/contract.types";
import { IProperty } from "@rentiohq/shared-frontend/dist/types/property.types";
import { IRegistration } from "@rentiohq/shared-frontend/dist/types/registration.types";
import {
  Error,
  Loading,
  MultiStepForm,
} from "@rentiohq/web-shared/dist/components";
import createRegistrationForm from "forms/registration";
import {
  isPerformingSubmitActionSelector,
  performingSubmitActionErrorSelector,
  performingSubmitActionResultSelector,
  submitActionCreator,
} from "forms/registration/schema.registration.actions";
import { IExtraData as IExtraDataCreateRegistration } from "forms/registration/schema.registration.types";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { IRootStore } from "redux/reducers";
import { ts } from "../../services";
import { isContractRegistrationPending } from "./RegistrationForm.utils";

export interface IProps {
  property: IProperty;
  contract: IContract;
  legalContact?: IContact;
  registration?: IRegistration;
}

export const ContractRegistrationForm = (props: IProps) => {
  const { property, contract, legalContact, registration } = props;

  const navigate = useNavigate();

  // Redux
  const dispatch = useDispatch();

  const { isBroker } = authHooks.useSelf();

  const [isLoading, setIsLoading] = React.useState(false);
  const [registrationId, setRegistrationId] = React.useState<
    number | undefined
  >(undefined);

  const contactMeMaster = useSelector((state: IRootStore) =>
    contactSelectors.getContactMeMaster(state),
  );

  // Fetch property amenities
  const { items: propertyAmenities, isFetching: isFetchingPropertyAmenities } =
    useGetPropertyAmenities({
      propertyId: property.id,
      shouldRefetch: true,
    });

  const fetchError = useSelector((state: IRootStore) =>
    rentRegistrationSelectors.fetchDetailError(state, registrationId),
  );

  const isFetchingRegistration = useSelector((state: IRootStore) =>
    rentRegistrationSelectors.isFetchingDetail(state, registrationId),
  );

  const onSuccess = (registration: IRegistration) => {
    const isPending = isContractRegistrationPending(registration);

    if (isPending) {
      setRegistrationId(registration.id);
      fetchRegistrationWithTimeout(registration.id);
    } else {
      navigate(`/properties/${property.id}?registrationId=${registration.id}`);
    }
  };

  function fetchRegistration(id: number) {
    dispatch(
      rentRegistrationActions.getDetailStart.getAction({
        id,
        onSuccess: result =>
          result?.data &&
          navigate(
            `/properties/${property.id}?registrationId=${result.data.id}`,
          ),
      }),
    );
  }

  function fetchRegistrationWithTimeout(id: number) {
    setIsLoading(true);

    setTimeout(() => {
      fetchRegistration(id);
    }, 10000);
  }

  // Render
  if (fetchError) {
    return <Error errors={[fetchError]} />;
  }

  const extraData: IExtraDataCreateRegistration = {
    contract,
    property,
    propertyAmenities,
    contactMeMaster,
    legalContact,
    isBroker,
    registration,
  };

  if (isLoading || isFetchingRegistration || isFetchingPropertyAmenities) {
    return <Loading />;
  }

  return (
    <MultiStepForm
      formId={`registration-general-${property.id}-${contract.id}`}
      schemas={createRegistrationForm(extraData)}
      withSummary={true}
      submitLabel={ts.system("save_send")}
      isPerformingSubmitActionSelector={isPerformingSubmitActionSelector(
        extraData,
      )}
      performingSubmitActionResultSelector={performingSubmitActionResultSelector(
        extraData,
      )}
      performingSubmitActionErrorSelector={performingSubmitActionErrorSelector(
        extraData,
      )}
      submitActionCreator={(formData: any) =>
        submitActionCreator(extraData)(formData)
      }
      onSuccess={onSuccess}
    />
  );
};
